import z from 'zod';

export const localesMap = {
    en: 'en',
    de: 'de',
    fr: 'fr',
    el: 'el',
    it: 'it',
    pl: 'pl',
    ro: 'ro',
    ru: 'ru',
    hu: 'hu',
    es: 'es',
    bg: 'bg',
    sl: 'sl',
    sr: 'sr',
    da: 'da',
    cs: 'cs',
    lt: 'lt',
};

type TEqualKeyValueMap<T> = { [K in keyof T]: K };
export const Locale = localesMap as TEqualKeyValueMap<typeof localesMap>;

export enum localeNamespace {
    common = 'common',
    machineTypeNames = 'machineTypeNames',
}

export enum LocaleEnum {
    en = 'en', // English
    de = 'de', // German
    fr = 'fr', // French
    el = 'el', // Greek
    it = 'it', // Italian
    pl = 'pl', // Polish
    ro = 'ro', // Romanian
    ru = 'ru', // Russian
    hu = 'hu', // Hungarian
    es = 'es', // Spanish
    bg = 'bg', // Bulgarian
    sl = 'sl', // Slovenian
    sr = 'sr', // Serbian
    da = 'da', // Danish
    cs = 'cs', // Czech
    lt = 'lt', // Lithuanian
}

export const LocaleSchema = z.nativeEnum(LocaleEnum);

export type TLocale = keyof typeof LocaleEnum;
